import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import SiteWrapper from "../../base/SiteWrapper";

import ProductCategory from '../../interfaces/ProductCategory';

import {
  Page,
  Button,
  Card,
  Text,
  Table
} from "tabler-react";
import { ApiFidegg } from "../../services/apiFideggAdmin";
import { Alerta } from "../../utils/Alerta";
import ReactPaginate from "react-paginate";

function ProductCategoriesList() {

  const history = useHistory();

  const [productCategories, setProductCategories] = useState<ProductCategory[]>([]);
  const [page, setPage]= useState(1);
  const [pageCount, setPageCount]= useState(0);

  useEffect(() => {
    updateProductCategoriesList();
  }, [page]);

  async function updateProductCategoriesList() {
    const params = { page };

    const response = await ApiFidegg.get('productcategories', { params });
    if (response.status === 200 && Array.isArray(response.data.categories)) {
      setProductCategories(response.data.categories);
      setPageCount(response.data.pages);
    }
  }

  const handlePaginate = useCallback((selectedItem: { selected: number }) => {
    setPage(selectedItem.selected + 1);
  }, []);

  function handleEditClick(productCategory: ProductCategory) {
    history.push(`/productcategories/form/${productCategory.id}`);
  }

  function handleClickAdd() {
    history.push('/productcategories/form');
  }

  const handleDeleteClick = useCallback(
    async (productCategory: ProductCategory) => {
      try {
        if(window.confirm("Confirma a exclusão da configuração de categoria?")) {
          await ApiFidegg.delete(`productcategories/${productCategory.id}`);

          Alerta('Configuração de Categoria Excluída!', 'success');

          updateProductCategoriesList();
        }
      } catch (err) {
        Alerta('Erro ao excluir configuração!');
      }
  }, []);

  return (
    <SiteWrapper>
      <Page.Content title="Categorias">
        <Card>
          <Card.Header>
            <Card.Title>Configurações por Categorias</Card.Title>
            <Card.Options>
              <Button
                RootComponent="a"
                color="secondary"
                size="sm"
                icon="plus"
                onClick={handleClickAdd}
              >
                Incluir
              </Button>
            </Card.Options>
          </Card.Header>
          <Table
            responsive
            className="card-table table-vcenter text-nowrap"
            headerItems={[
              { content: "Descrição"},
              { content: "Valor"},
              { content: null },
            ]}
            bodyItems={
              productCategories?.map((productCategory: ProductCategory) => {
                return {
                  key: productCategory.id,
                  item: [
                    {
                      content: (
                        <Text>
                          {productCategory.description}
                        </Text>
                      ),
                    },
                    {
                      content: (
                        <Text>
                          {productCategory.value}
                        </Text>
                      ),
                    },
                    {
                      alignContent: "right",
                      content: (
                        <>
                          <Button
                            RootComponent="a"
                            color="secondary"
                            size="sm"
                            className="m-1"
                            icon="edit"
                            onClick={() => handleEditClick(productCategory)}
                          />
                          <Button
                            RootComponent="a"
                            color="secondary"
                            size="sm"
                            className="m-1"
                            icon="trash"
                            onClick={() => handleDeleteClick(productCategory)}
                          />
                        </>
                      ),
                    },
                  ]
                }
              })
            }
          />
          <Card.Footer>
            <ReactPaginate
              previousLabel={'<'}
              nextLabel={'>'}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={pageCount}
              marginPagesDisplayed={1}
              pageRangeDisplayed={2}
              onPageChange={handlePaginate}
              containerClassName={'pagination'}
              activeClassName={'active'}
            />
          </Card.Footer>
        </Card>
      </Page.Content>
    </SiteWrapper>
  );
}

export default ProductCategoriesList;